import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2, { getPageWiseUserCampaignList } from "../../../../services/iqApiV2";
import { FETCH_SPOT_CONTACTS_REQUEST, FetchSpotContactsFailure, FetchSpotContactsSuccess } from "../../actions/targetedReachout/spotContactsActions";
import { deepFlatten, normalizeMappedProducts } from "../../../../utilities/uiUtils";




async function spotContacts(clientName, accountName, userId, type = 'spot') {

try {
  const response = await iq_api_v2.post('/contact/list_contacts', null, {
    params: {
      user_id: userId,
      client: clientName,
      account: accountName,
    },
  });
  return response?.data?.result;
} catch (error) {
  console.error('Error:', error.response ? error.response.data : error.message);
}

  }

// Worker Saga
function* fetchSpotContactsSaga() {
  try {
    const payload = yield select(
      (state) => state?.spotContactsReducer?.payload
    );
    const { clientName, accountName, userId, type } = payload;

    // Fetch contacts and existing nurtures
    const data = yield call(spotContacts, clientName, accountName, userId, type);
    const dataOfExistingNurtures = yield call(
      getPageWiseUserCampaignList,
      userId,
      // "TRO"
    );

    // Step 1: Sort by relevant_keywords length (descending)
    const sortedByOpportunity = [...data].sort((a, b) => {
      const dataA  = deepFlatten(a?.relevant_keywords);
      const dataB  = deepFlatten(b?.relevant_keywords);
      const aLen = dataA?.length || 0;
      const bLen = dataB?.length || 0;
      return bLen - aLen;
    });

    // Step 2: Sort by bookmark flag (descending)
    const sortedByBookmark = [...sortedByOpportunity].sort((a, b) => {
      const aLen = a?.is_bookmarked ? 1 : 0;
      const bLen = b?.is_bookmarked ? 1 : 0;
      return bLen - aLen;
    });

    // Step 3: Sort by unread first (is_read === false)
    const sortedDataByNewArrival = [...sortedByBookmark].sort((a, b) => {
      const aRead = a?.is_read === false ? -1 : 1;
      const bRead = b?.is_read === false ? -1 : 1;
      return aRead - bRead;
    });

    // Step 4: Add "autonurture_in_progress" if id matches any nurture’s for_contactid
// ✅ Use Map instead of Set
      const nurtureContactMap = new Map(
        (dataOfExistingNurtures || [])
          .filter((n) => n?.for_contactid) // keep only valid ones
          .map((n) => [n.for_contactid, n.status])
      );

      console.log("nurtureContactMap",dataOfExistingNurtures, nurtureContactMap);

      // ✅ Now enrich your data using the map
      const enrichedData = (sortedDataByNewArrival || []).map((item) => {
        const contactStatus = nurtureContactMap.get(item?.id);

        return {
          ...item,
          autonurture_in_progress: nurtureContactMap.has(item?.id),
          auto_nurture_status: contactStatus || null, // new key for clarity
          caseType: "sales_play",
        };
      });
           
      const normalizedData = (enrichedData || []).map((item) => {
        const mappedProducts  = deepFlatten(item?.products_mapped);
        const after = normalizeMappedProducts(mappedProducts);
        const after2 =  after?.map(item => item?.trim().toLowerCase())
        const uniqueData = new Set(after2);
        
        const finalResult  = [...uniqueData]

        return {
          ...item,
          products_mapped: finalResult,
        };
      });


    yield put(FetchSpotContactsSuccess(normalizedData));
  } catch (error) {
    yield put(FetchSpotContactsFailure(error.message));
  }
}

// Watcher Saga
export function* watchSpotContactsSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_REQUEST, fetchSpotContactsSaga);

}
